import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgPinServiceSiteSecondaryRestricted = (props, ref) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsxs("g", { id: "Icons/Map/PinServiceSiteSecondary/Restricted", children: [
    /* @__PURE__ */ jsxs("g", { id: "Ellipse 22", filter: "url(#filter0_d_14145_143933)", children: [
      /* @__PURE__ */ jsx("circle", { cx: 12, cy: 12, r: 8, fill: "#999999" }),
      /* @__PURE__ */ jsx("circle", { cx: 12, cy: 12, r: 7.5, stroke: "black", strokeOpacity: 0.2 })
    ] }),
    /* @__PURE__ */ jsx("circle", { id: "Ellipse 23", cx: 12, cy: 12, r: 4, fill: "white" })
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("filter", { id: "filter0_d_14145_143933", x: 0, y: 0, width: 24, height: 24, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
    /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
    /* @__PURE__ */ jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsx("feOffset", {}),
    /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 2 }),
    /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
    /* @__PURE__ */ jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0" }),
    /* @__PURE__ */ jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_14145_143933" }),
    /* @__PURE__ */ jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_14145_143933", result: "shape" })
  ] }) })
] });
const ForwardRef = forwardRef(SvgPinServiceSiteSecondaryRestricted);
export { ForwardRef as ReactComponent };
